module Meevo.Plugins.Services {
    "use strict";

    export class ServiceNotificationTemplateSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ServiceNotificationOverride> {

        resetSendBcc(index: number) {
            if (Model.Guard.isNothing(this.model.templates[index].templateDataDetail))
                this.model.templates[index].sendBcc = false;
        }

    }
}